import { useLocation, useMatch } from "react-router-dom";
import { TouchTargetLink } from "@/components/templates/parts";
import { ReportRecordNext } from "./ReportRecordNext";
import { REPORT_RECORD_LINK_CLASS, reportRecordName, resolveReportSection } from "./reportRecordSections";

/**
 * A report record the viewer may not open, under the next layout (NAVIGATION_AND_STATES.md, T2 no
 * permission: the hero shows the name only and the tabs are locked). `ReportsAccessGate` renders
 * it in place of the runner, which never mounts, so no org-wide report data is fetched.
 * Presentational: the report's name comes from its static definition.
 */
export function ReportRecordForbidden({ leadsMinistry }: { leadsMinistry: boolean }) {
  // The gate is a layout route, so the runner's params are matched here rather than read.
  const direct = useMatch("/reports/:reportKey");
  const sectioned = useMatch("/reports/:reportKey/:section");
  const { search } = useLocation();
  const reportKey = direct?.params.reportKey ?? sectioned?.params.reportKey ?? "";
  const section = resolveReportSection(sectioned?.params.section) ?? "results";
  return (
    <ReportRecordNext
      reportKey={reportKey}
      section={section}
      search={search}
      name={reportRecordName(reportKey)}
      state={{
        kind: "forbidden",
        title: "Org-wide reports are limited to admins",
        permission: "Org-wide report access",
      }}
      after={leadsMinistry
        ? (
          // The classic gate's way through for ministry leaders, kept reachable.
          <p className="mx-auto mt-[var(--density-page-gap)] w-full max-w-[var(--layout-max-width)] text-sm text-muted-foreground">
            You can still see your ministry's participation, serving and roster.{" "}
            <TouchTargetLink to="/volunteer/leader/reports" className={REPORT_RECORD_LINK_CLASS}>
              Go to my leader reports
            </TouchTargetLink>
          </p>
        )
        : undefined}
    >
      {null}
    </ReportRecordNext>
  );
}
